module.exports = __webpack_public_path__ + "img/page-banner.2779febb.jpg";